
    <div class="d-flex flex-column align-items-center">
        <div class="alert alert-success w-100">
            <h5>{{ 'Game.TotalWords2' | translate:locale.language }}:</h5>
            <span class="m-1" *ngFor="let word of wrResult.words; index as r">{{word}}</span>
            <span class="m-1">{{ 'Project.County' | translate:locale.language }}</span>
        </div>

        <table class="table table-bordered text-center bg-white">
            <tbody>
                <tr>
                    <th>
                        {{ 'Game.Round' | translate:locale.language }}
                    </th>
                    <th *ngIf="lang == 'hu-HU'">
                        {{ 'Project.LastName' | translate:locale.language }}
                    </th>
                    <th>
                        {{ 'Project.FirstName' | translate:locale.language }}
                    </th>
                   <th *ngIf="lang != 'hu-HU'">
                        {{ 'Project.LastName' | translate:locale.language }}
                    </th>
                    <th>
                        {{ 'Project.PublicSpace' | translate:locale.language }}
                    </th>
                    <th>
                        {{ 'Project.NatureOfPublicSpace' | translate:locale.language }}
                    </th>
                    <th>
                        {{ 'Project.HouseNumber' | translate:locale.language }}
                    </th>
                    <th>
                        {{ 'Project.City' | translate:locale.language }}
                    </th>
                    <th>
                        {{ 'Project.County' | translate:locale.language }}
                    </th>
                </tr>
                <!-- <tr *ngFor="let round of [0,1,2]">
                    <td style="align-items: flex-end;">
                        {{round+1}} 
                    </td>
                    <td *ngFor="let word of wrResult.recallRounds[round].guessWords">
                        {{word.guessWord}}
                    </td>
                </tr>
                <tr>
                    <td style="align-items: flex-end;">
                        {{ 'Task.Solved' | translate:locale.language }}
                    </td>
                    <td *ngFor="let word of wrResult.recallRounds[2].guessWords">
                        <dx-check-box [(value)]="word.correct">
                        </dx-check-box>
                     </td>
                </tr> -->

                <tr *ngIf="wrResult.recallRounds[0]">
                    <td style="align-items: flex-end;">
                        1 
                    </td>
                    <td *ngFor="let word of wrResult.recallRounds[0].guessWords">
                        {{word.guessWord}}
                    </td>
                </tr>
                <tr *ngIf="wrResult.recallRounds[0] && gameType == 'AKV'">
                    <td style="align-items: flex-end;">
                        {{ 'Task.Solved' | translate:locale.language }}
                    </td>
                    <td *ngFor="let word of wrResult.recallRounds[0].guessWords">
                        <dx-check-box [ngClass]="word.correct ? 'correct' : 'incorrect'" [(value)]="word.correct">
                        </dx-check-box>
                     </td>
                </tr>

                <tr *ngIf="wrResult.recallRounds[1]">
                    <td style="align-items: flex-end;">
                        2 
                    </td>
                    <td *ngFor="let word of wrResult.recallRounds[1].guessWords">
                        {{word.guessWord}}
                    </td>
                </tr>
                <tr *ngIf="wrResult.recallRounds[1] && gameType == 'AKV'">
                    <td style="align-items: flex-end;">
                        {{ 'Task.Solved' | translate:locale.language }}
                    </td>
                    <td *ngFor="let word of wrResult.recallRounds[1].guessWords">
                        <dx-check-box [ngClass]="word.correct ? 'correct' : 'incorrect'" [(value)]="word.correct">
                        </dx-check-box>
                     </td>
                </tr>
                <tr *ngIf="wrResult.recallRounds[2]">
                    <td style="align-items: flex-end;">
                        3 
                    </td>
                    <td *ngFor="let word of wrResult.recallRounds[2].guessWords">
                        {{word.guessWord}}
                    </td>
                </tr>
                <tr *ngIf="wrResult.recallRounds[2] && gameType == 'AKV'">
                    <td style="align-items: flex-end;">
                        {{ 'Task.Solved' | translate:locale.language }}
                    </td>
                    <td *ngFor="let word of wrResult.recallRounds[2].guessWords">
                        <dx-check-box [ngClass]="word.correct ? 'correct' : 'incorrect'" [(value)]="word.correct">
                        </dx-check-box>
                     </td>
                </tr>

                <tr *ngIf="wrResult.recallRounds[3]">
                    <td style="align-items: flex-end;">
                        4 
                    </td>
                    <td *ngFor="let word of wrResult.recallRounds[3].guessWords">
                        {{word.guessWord}}
                    </td>
                </tr>
                <tr *ngIf="wrResult.recallRounds[3]">
                    <td style="align-items: flex-end;">
                        {{ 'Task.Solved' | translate:locale.language }}
                    </td>
                    <td *ngFor="let word of wrResult.recallRounds[3].guessWords">
                        <dx-check-box [ngClass]="word.correct ? 'correct' : 'incorrect'" [(value)]="word.correct" [disabled]="gameType != 'AKV'">
                        </dx-check-box>
                     </td>
                </tr>

            </tbody>
        </table>

         <!-- Utolsó forduló hibáinak javítása -->
         <div *ngIf="wrResult.recallRounds[3] && wrResult.result1 < 7 && gameType != 'AKV'" class="container text-center">

             <div *ngIf="!wrResult.recallRounds[3].guessWords[0].correct || !wrResult.recallRounds[3].guessWords[1].correct" class="row">
                <div *ngFor="let item of [0,1,2]" class="col-lg-4">
                    <div class="card shadow mx-1 my-2">
                    <div [ngClass]="{'selected': wrResult.recallRounds[4].guessWords[item].correct}" class="card-body w-100">
                        {{wrResult.recallRounds[4].guessWords[item].guessWord}}
                        <span *ngIf="wrResult.recallRounds[4].guessWords[item].correct && wrResult.recallRounds[4].guessWords[item].answer" class="ms-2">
                        <dx-check-box class="correct" [disabled]="true" [(value)]="wrResult.recallRounds[4].guessWords[item].correct">
                        </dx-check-box>
                        </span>
                    </div>

                </div>
                </div>
            </div>
            <div *ngIf="!wrResult.recallRounds[3].guessWords[2].correct || !wrResult.recallRounds[3].guessWords[3].correct" class="row">
                <div *ngFor="let item of [3,4,5]" class="col-lg-4">
                    <div class="card shadow mx-1 my-2">
                        <div [ngClass]="{'selected': wrResult.recallRounds[4].guessWords[item].correct}" class="card-body w-100">
                        {{wrResult.recallRounds[4].guessWords[item].guessWord}}
                        <span *ngIf="wrResult.recallRounds[4].guessWords[item].correct && wrResult.recallRounds[4].guessWords[item].answer" class="ms-2">
                            <dx-check-box class="correct" [disabled]="true" [(value)]="wrResult.recallRounds[4].guessWords[item].correct">
                            </dx-check-box>
                            </span>
                            </div>
                    </div>
                </div>
            </div>
            <div *ngIf="!wrResult.recallRounds[3].guessWords[4].correct" class="row">
                <div *ngFor="let item of [6,7,8]" class="col-lg-4">
                    <div class="card shadow mx-1 my-2">
                        <div [ngClass]="{'selected': wrResult.recallRounds[4].guessWords[item].correct}" class="card-body w-100">
                        {{wrResult.recallRounds[4].guessWords[item].guessWord}}
                        <span *ngIf="wrResult.recallRounds[4].guessWords[item].correct && wrResult.recallRounds[4].guessWords[item].answer" class="ms-2">
                            <dx-check-box class="correct" [disabled]="true" [(value)]="wrResult.recallRounds[4].guessWords[item].correct">
                            </dx-check-box>
                            </span>
                            </div>
                    </div>
                </div>
            </div>
            <div *ngIf="!wrResult.recallRounds[3].guessWords[5].correct" class="row">
                <div *ngFor="let item of [9,10,11]" class="col-lg-4">
                    <div class="card shadow mx-1 my-2">
                        <div [ngClass]="{'selected': wrResult.recallRounds[4].guessWords[item].correct}" class="card-body w-100" >
                        {{wrResult.recallRounds[4].guessWords[item].guessWord}}
                        <span *ngIf="wrResult.recallRounds[4].guessWords[item].correct && wrResult.recallRounds[4].guessWords[item].answer" class="ms-2">
                            <dx-check-box class="correct" [disabled]="true" [(value)]="wrResult.recallRounds[4].guessWords[item].correct">
                            </dx-check-box>
                            </span>
                            </div>
                    </div>
                </div>
            </div>
            <div *ngIf="!wrResult.recallRounds[3].guessWords[6].correct" class="row">
                <div *ngFor="let item of [12,13,14]" class="col-lg-4">
                    <div class="card shadow mx-1 my-2">
                        <div [ngClass]="{'selected': wrResult.recallRounds[4].guessWords[item].correct}" class="card-body w-100" >
                        {{wrResult.recallRounds[4].guessWords[item].guessWord}}
                        <span *ngIf="wrResult.recallRounds[4].guessWords[item].correct && wrResult.recallRounds[4].guessWords[item].answer" class="ms-2">
                            <dx-check-box class="correct" [disabled]="true" [(value)]="wrResult.recallRounds[4].guessWords[item].correct">
                            </dx-check-box>
                            </span>
                            </div>
                    </div>
                </div>
            </div>
        
        </div>
        
    </div>

